import React from 'react'
import { Grid, Typography } from '@material-ui/core/'
import readM from '../../../../../../../assetss/img/readM.svg'
import noReadM from '../../../../../../../assetss/img/noReadM.svg'
import './index.scss'

const MessageAvtor = ({ time, read, name, text, id, onDeleteMeesage, setIdHandler, deleteId, updateMessage }) => {
  return (
    <Grid
      className='messAvtorBox'
      onClick={() => setIdHandler(id)}
    >
      <Grid className='messageBox'>
        <Grid className='message'>
          <Grid className='textDateBox'>
            <Typography className='text'>{text}</Typography>
            <Typography className='time'>{time}</Typography>
          </Grid>
          {read ? <img src={noReadM} /> : <img src={readM} />}
        </Grid>
        <Typography className='avatarUser'>{name}</Typography>
      </Grid>
      {id === deleteId && (
        <Grid className='deleteMessBox'>
          <Typography onClick={() => updateMessage(text, id)} className='editTextBtn'>Edit message</Typography>
          <Typography onClick={onDeleteMeesage} className='deleteTextBtn'>Delete message for everyone</Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default MessageAvtor
